import React, { useState, useEffect } from 'react';
import NavigationBar from '../Components/NavigationBar/NavigationBar';
import api from '../services/api';
import './AssetVerification.css';

function VerifiedAssets({ user }) {
    const [verifiedAssets, setVerifiedAssets] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const justVerified = sessionStorage.getItem('justVerifiedAssets');
        if (justVerified) {
            setVerifiedAssets(JSON.parse(justVerified));
            sessionStorage.removeItem('justVerifiedAssets');
        }
        setLoading(false);
    }, []);

    const formatDate = (isoString) => {
        const date = new Date(isoString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    };

    if (loading) {
        return <div className="verification-container">Loading...</div>;
    }

    return (
        <div>
            <NavigationBar user={user} />
            <div style={{ padding: '20px' }}>
                <h3>Asset Verification Summary</h3>

                <table className="styled-table">
                    <thead>
                        <tr>
                            <th>Asset No</th>
                            <th>Verified By</th>
                            <th>Verified On</th>
                        </tr>
                    </thead>
                    <tbody>
                        {verifiedAssets.length === 0 ? (
                            <tr>
                                <td colSpan="3">No verified assets found</td>
                            </tr>
                        ) : (
                            verifiedAssets.map((asset) => (
                                <tr key={asset.asset_no}>
                                    <td>{asset.asset_no}</td>
                                    <td>{asset.verified_by}</td>
                                    <td>{formatDate(asset.verified_on)}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default VerifiedAssets;